




























































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import DevExpress from 'devextreme/bundles/dx.all';
import dialog from 'devextreme/ui/dialog';
import { DataGrid } from '@questelservices/common-vue';
import { DxButton } from 'devextreme-vue/button';
import {DxDataGrid, DxEditing, DxColumn, DxFilterRow, DxStateStoring, DxScrolling, DxHeaderFilter, DxPager, DxPaging } from 'devextreme-vue/data-grid';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import { FileParseUploadDto } from '@/models/file-parsing/FileParseUploadDto';
import { FileParseUploadStatusTypeEnum, FileParseUploadStatusTypeEnumString } from '@/models/file-parsing/FileParseUploadStatusTypeEnum';
import { FileParseUploadService } from '@/service/FileParseUploadService';

@Component({
  components: {
    DataGrid,
    DxDataGrid,
    DxButton,    
    DxColumn,
    DxFilterRow,
    DxEditing,
    DxStateStoring,
    DxScrolling,
    DxHeaderFilter,
    DxPager,
    DxPaging
  }
})
export default class FileParseSubmittedFiles extends Vue {
  $refs: Vue['$refs'] & {
      fileParseUploadDataGrid?: DataGrid;
    } = {};

  private submittedFilesStoreOptions: DevExpress.data.CustomStoreOptions;
  private fileParseUploadService: FileParseUploadService = new FileParseUploadService();
  initialLoad: boolean = true;

  private get dataGrid(): DevExpress.ui.dxDataGrid {
        return (this.$refs.fileParseUploadDataGrid as any).$refs.dxDataGrid.instance;
    }
  
  constructor() {
    super();

    this.submittedFilesStoreOptions = {
      key: 'FileParseUploadId',
      load: (loadOptions) => {
        if(loadOptions.filter === undefined) {
            loadOptions.filter = [];
        }
        if (this.initialLoad) {
          this.initialLoad = false;
          this.applyDefaultSort();
        }
        
        return this.fileParseUploadService.search(loadOptions);
      }
    }
  }  

  getAgentName(rowData: any) {
    return rowData.Agent == null ? '' : rowData.Agent.AgentName;
  }

  getStatus(rowData: any){
    let result = "";
    switch (rowData.StatusType)
    {
      case FileParseUploadStatusTypeEnum.Created:
        result = FileParseUploadStatusTypeEnumString.Created;
        break;
      case FileParseUploadStatusTypeEnum.Uploading:
        result = FileParseUploadStatusTypeEnumString.Uploading;
        break;
      case FileParseUploadStatusTypeEnum.Uploaded:
        result = FileParseUploadStatusTypeEnumString.Uploaded;
        break;
      case FileParseUploadStatusTypeEnum.InQueue:
        result = FileParseUploadStatusTypeEnumString.InQueue;
        break;
      case FileParseUploadStatusTypeEnum.NeedsReview:
        result = FileParseUploadStatusTypeEnumString.NeedsReview;
        break;
      case FileParseUploadStatusTypeEnum.Processing:
        result = FileParseUploadStatusTypeEnumString.Processing;
        break;
      case FileParseUploadStatusTypeEnum.Complete:
        result = FileParseUploadStatusTypeEnumString.Complete;
        break;
      case FileParseUploadStatusTypeEnum.Failed:
        result = FileParseUploadStatusTypeEnumString.Failed;
        break;
      case FileParseUploadStatusTypeEnum.TimedOutWhileCompletingUpload:
        result = FileParseUploadStatusTypeEnumString.TimedOutWhileCompletingUpload;
        break;
      case FileParseUploadStatusTypeEnum.NeedsResubmission:
        result = FileParseUploadStatusTypeEnumString.NeedsResubmission;
        break;
      case FileParseUploadStatusTypeEnum.TimedOutDuringUpload:
        result = FileParseUploadStatusTypeEnumString.TimedOutDuringUpload;
        break;
      default:
        result = 'Unknown Status';
    }
    return result;
  }

  private resubmitInProgress: boolean = false;
  private async resubmitFileParseUpload(rowData: any)
  {
    this.resubmitInProgress = true;
    rowData.data.StatusType = 1;
    await this.fileParseUploadService.submit(rowData.data.FileParseUploadId);
    this.refreshFileParseUploadTable();
    this.resubmitInProgress = false;
  }

  private async refreshFileParseUploadTable() {
    this.dataGrid.refresh();
  }

  private showResubmitButton(data: any) {
    return data.data.StatusType === FileParseUploadStatusTypeEnum.TimedOutWhileCompletingUpload ||
      data.data.StatusType === FileParseUploadStatusTypeEnum.NeedsResubmission;
  }
  
  private applyDefaultSort() {
    this.dataGrid.columnOption('CreatedDate', 'sortOrder', 'desc');
  }  
}
